import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { CollapsibleCard } from '../../../../containers/Cards/Collapsible/CollapsibleCard';
import { AssignedSurveyDateLine } from '../dateLines';
import { AssignedSurveyGoalSummary } from '../summaries/AssignedSurveyGoalSummary';
import { GoalCardActionItems } from '../../shared-types';
import { IconAvatar } from '../../../../display/IconAvatar/IconAvatar';
import { applyMustacheTemplate } from '@act/shared/utilities';

interface AssignedSurveyGoalCardProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
  member: UserDto;
  actions?: GoalCardActionItems[];
  defaultClosed?: boolean;
  onToggleOpen?: () => void;
  summary?: JSX.Element;
}

export const AssignedSurveyGoalCard = ({
  assignedSurvey,
  member,
  actions,
  defaultClosed,
  onToggleOpen,
  summary,
}: AssignedSurveyGoalCardProps) => {
  const templateVariables = {
    memberName: `${member?.firstName || 'Unknown'}` ,
    month: new Date().toLocaleString('default', { month: 'long' }),
  }
  const surveyTitle = `${applyMustacheTemplate(assignedSurvey.survey.displayName, templateVariables)} survey`;
  
  return (
    <CollapsibleCard
      avatar={<IconAvatar avatarType="survey" />}
      title={surveyTitle}
      titleTypographyVariant="titleMedium"
      endContent={
        <AssignedSurveyDateLine
          assignedSurvey={assignedSurvey}
          member={member}
        />
      }
      defaultClosed={defaultClosed}
      isCompact
      hideExpander
      shouldShowPointer
      onToggleOpen={onToggleOpen}
    >
      <AssignedSurveyGoalSummary
        assignedSurvey={assignedSurvey}
        member={member}
        summary={summary}
        actions={actions}
      />
    </CollapsibleCard>
  );
};
